export default __webpack_public_path__ + "static/media/home-service-logo-right.a3ca31e4.svg";